import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { logError } from "../logging";
import { checkAuthentication } from "./identity";

export const useAuth = (onAuthenticated: () => void, onNotAuthenticated: () => void) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const isAuthenticated = await checkAuthentication();
        setIsAuthenticated(isAuthenticated);

        if (isAuthenticated) {
          onAuthenticated();
        } else {
          onNotAuthenticated();
        }
      } catch (error) {
        logError(error, "[useAuth] checkAuthentication");
        navigate("/error");
      }
    };

    checkAuth();
    // eslint-disable-next-line
  }, []);

  return isAuthenticated;
};
